<template>
  <v-switch
    v-model="on"
    class="mt-0 mb-2 ml-1"
    dense
    hide-details
    inset
    :disabled="disabled"
    :label="label"
    :readonly="readonly"
    :right="right"
    :ripple="false"
  />
</template>

<style>
</style>

<script>
export default {
  props: {
    field: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    on: {
      get: function() { return this.value },
      set: function(value) {
        const field = this.field
        this.$emit('change', { field, value })
      }
    }
  }
}
</script>
